export default __webpack_public_path__ + "static/media/image-not-found.a2c62d07.svg";